import { render, staticRenderFns } from "./customer-type-select.vue?vue&type=template&id=a64be750&scoped=true&"
import script from "./customer-type-select.vue?vue&type=script&lang=js&"
export * from "./customer-type-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64be750",
  null
  
)

export default component.exports